import { AutomationRuleTriggersEnum } from 'modules/automation-rules/triggers/enums/trigger-enum'
import { AutomationRulesTriggersEditType } from 'modules/automation-rules/triggers/types/automation-rule-triggers-edit-interface'
import { StoreId } from 'modules/stores/types/stores-interface'

export interface StoreTriggerDataInterface {
  storeId: StoreId
  storeName: string
  itemId: number
  itemName: string
}
export const fillTriggerWithStoreData = (
  trigger: AutomationRulesTriggersEditType,
  data: StoreTriggerDataInterface,
): AutomationRulesTriggersEditType => {
  switch (trigger.type) {
    case AutomationRuleTriggersEnum.digital_store_form_subscribed:
      return {
        ...trigger,
        digitalStore: { id: data.storeId, name: data.storeName },
        itemOptIn: { id: data.itemId, title: data.itemName },
      }

    default:
      return trigger
  }
}
